// @flow @format
import {connect} from 'react-redux';
import UserSelect from '../components/UserSelect';

import type {State} from '../reducers';

const mapStateToProps = ({selection, session, entities}: State) => {
	return {
		user: entities.users.entities[selection.userId],
		users: entities.users.byGroup[session.group],
	};
};

export default connect(mapStateToProps)(UserSelect);



// WEBPACK FOOTER //
// ./src/containers/UserSelectContainer.js